import React from 'react'
import { useChargingPoint } from '@services/device'
import { Select, SelectProps } from '@shared/Form/Select'
import { useTranslation } from 'react-i18next'
import { pathOr } from 'ramda'

type Props = SelectProps & {
  filterItem?: any[]
  autoCompleteInput?: string
}

export const ChargingPointSelect = React.forwardRef<typeof Select, Props>(
  (props, ref): any => {
    const { t } = useTranslation()

    const query = React.useMemo(
      () => ({
        pageNum: 0,
        pageSize: 10,
        sessionId: 1,
        input: props?.autoCompleteInput || '',
      }),
      [props]
    )

    const { dataSource, isLoading } = useChargingPoint(query)
    const _dataSource: any = dataSource

    // console.log('_dataSource',_dataSource);

    return (
      <Select
        allowClear
        placeholder={t('device:select ChargingPointTypes')}
        {...props}>
        {(pathOr([], ['data'], _dataSource) || []).map((x: any) => (
          <Select.Option key={x?.types} value={x?.types}>
            {x?.types}
          </Select.Option>
        ))}
      </Select>
    )
  }
)

export default ChargingPointSelect
